<div class="dashboard-container">

    <!-- Page header -->
    <div class="dashboard-header">
        <h1>Dashboard</h1>
    </div>

    <!-- Top panel -->
    <div class="dashboard-top-panel" *ngIf="isLoader">
        <div class="dashboard-top-item" *ngFor="let item of data?.TopPanel; index as i">
            <div class="dashboard-alert">
                <i class="{{ item.icon }} dashboard-alert__icon"></i>&nbsp;{{ item.key | titlecase }}
                <hr />
                <ul class="dashboard-chips">
                    <li class="dashboard-chip" *ngFor="let chip of getSplitValue(item.value)">
                        <span class="dashboard-chip__badge">{{ chip }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <hr *ngIf="isLoader" />

    <!-- Bottom panel -->
    <div class="dashboard-bottom-panel" *ngIf="isLoader">
        <div class="dashboard-bottom-item" *ngFor="let item of data?.BottomPanel; index as i">
            <div class="dashboard-card">
                <div class="dashboard-card__header">
                    <i class="{{ item.icon }} dashboard-card__icon"></i>&nbsp;
                    <h5>{{ item.Title }}</h5>
                </div>
                <div class="dashboard-card__body">
                    <h4 class="dashboard-card__title">{{ item.Description }}</h4>
                    <h6 *ngIf="item.dataobject?.key">{{ item.dataobject.key }}</h6>
                    <ul class="dashboard-chips" *ngIf="item.dataobject?.value">
                        <li class="dashboard-chip" *ngFor="let chip of getSplitValue(item.dataobject.value)">
                            <span class="dashboard-chip__badge dashboard-chip__badge--info">{{ chip }}</span>
                        </li>
                    </ul>
                    <hr *ngIf="item.chartData" />
                    <div class="dashboard-chart" *ngIf="item.chartData">
                        <app-chart-canvas
                            [canvasId]="item.canvasId"
                            [data]="item.chartData"
                            [type]="item.chartType">
                        </app-chart-canvas>
                    </div>
                </div>
                <div class="dashboard-card__footer" *ngIf="item.hyperlink">
                    <a [href]="item.hyperlink">Click to view more</a>
                </div>
            </div>
        </div>
    </div>

    <!-- Loading spinner -->
    <div class="dashboard-loading" *ngIf="!isLoader">
        <div class="dashboard-loading__spinner">
            <div class="spinner"></div>
            <span>Loading...</span>
        </div>
    </div>

</div>
